var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 51,
    fill: "url(#pattern0_368_60)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_368_60",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_368_60",
    transform: "matrix(0.0111111 0 0 0.0104575 0 0.0294118)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_368_60",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC8ElEQVR4nO2dP2sUQRyGBxWjVcpEsfFPhHwFw1mYWMWPED9CtNMiokWadIoIJmqhn0BiryZaWYpiBC2uMFUwIucJNj6yMCGrzt5dbmdmdzbvAwcH997Nbx6W2Z2ZZc8YIYQQQgghhGgywEXgIfAR+GFfG8ADYKbq+pIHOAus0581YKLqepMEOA9sMzjbQKvqulM8kvcieYevwJk+v50Km8AScDik6EGGiyJeNkT0DkshT3xlmW6Q6M1Qoh95KG6lQaIJJTq7hCvLhkT3F93xUFtHouOI/m4SJMWh44NJkNiis6l2WZZNgsQWPeNB9AWTIFFF2wafl5C8ZhKlCtEnga0QU/A6E120bbRlxe1FcsskTCWibcMT2drFAJJfpHwkVy46V8B0Nq3OLtvsdXbHvl9J9cRXS9H7BSQ6DhIdCYmOhERHQqKbLBo4AlwF3tj7OKriG3APONrEKfgJ4C31YjlYh3f77STkkVw3yRld4ECQTu/23UmoxrLhoo50myY6G5PryP0gHf67707qvGfok+yOqbuNOxl6FPQLuAYcN4mQqujrJjFSFX3MJEaSok2CSHQkJDoSEh0JiY6EREdCoi2ha4jZF4mO1BeJbopo0sT/Lo+vykyzRPvf5fFVkWmmaH+bD74qMhIt0bXY5cETplmi/e/y9GnwE3AKOA187hU0opToxVxuUaLDiZ7P5a5IdDjRc7ncZYkOJ3o2l7sk0eFEn8vlpiQ6nOjJXG5SosOJHs/lxiU6nOiRXG5EokvQw13Xkf0p0f5Ff3Fks0eWORm2/X0DxbxzZN8XhY0YWvQrR/a1RPsXverIPpNo/6IfO7JPJNq/6NuO7B2J9i/6piN7S6L9i553ZAuXSo0YWvScI1u4VGrE0KJnHdnCpVIjhhY95cgWLpUa0Rug7fD2GxhzZMfsZ//Srqb6hABu/KcNnvbIrzryC3GrThDgkJXdtg8ZzJ4ENtojP2r/JmTLfmcBOBi3aiGEEEIIIYQQpog/NvqVQPjH5wIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.86825e0d8874b6385a507bf9800c4aca.svg";
export { ForwardRef as ReactComponent };